import React from 'react';
import PropTypes from 'prop-types';

import { branch } from 'baobab-react/higher-order';

import Block, { LOCATIONS } from '@components/common/block';
import Button from '@components/common/button';
import Input from '@components/common/input';
import BLOCKS from '@store/blocks';
import { CROSSHAIR_SETUP } from './actions';

import styles from './index.module.css';

const HEADERS = ['2. Pick Coordinates', '2. Pick Start', '3. Pick End'];

class PickCoordsBlock extends React.Component {
  constructor(props) {
    super(props);

    const idx = props.index < 3 ? 0 : 1;
    this._onStartChange = props.dispatch.bind(null, CROSSHAIR_SETUP, idx, 'x');
    this._onEndChange = props.dispatch.bind(null, CROSSHAIR_SETUP, idx, 'y');
  }

  render() {
    let props = this.props;
    let idx = props.index - 1;
    let x = -1;
    let y = -1;
    let myIndex = idx < 2 ? 0 : 1;

    if (props.settingIdx === myIndex) {
      x = this.props.posPicking.x;
      y = this.props.posPicking.y;
    } else if (props.posSet[myIndex].x > -1 || props.posSet[myIndex].y > -1) {
      x = props.posSet[myIndex].x;
      y = props.posSet[myIndex].y;
    }

    return (
      <Block
        header={HEADERS[idx]}
        location={LOCATIONS.TOP}
        className={`${styles.block} ${idx ? styles.blockShort : ''}`}>
        <div className={styles.text}>
          To pick your coordinates, click on button “Select” and anywhere on the
          map:
        </div>
        <Button onClick={props.onStartPicking} className={styles.selectButton}>Select</Button>
        <div className={styles.text}>Or type in:</div>
        <div>
          <label className={styles.label}>
            X:{' '}
            <Input
              className={styles.input}
              value={x >= 0 ? x : ''}
              onChange={this._onStartChange}
            />
          </label>
          <label className={styles.label}>
            Y:{' '}
            <Input
              className={styles.input}
              value={y >= 0 ? y : ''}
              onChange={this._onEndChange}
            />
          </label>
        </div>
      </Block>
    );
  }
}

PickCoordsBlock.defaultProps = {
  index: 1,
};

PickCoordsBlock.propTypes = {
  index: PropTypes.number,
  onStartPicking: PropTypes.func,
  posPicking: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  posSet: PropTypes.array,
  settingIdx: PropTypes.number
};

export default branch(
  {
    settingIdx: BLOCKS.MAP.CROSSHAIR_SETTING,
    posPicking: BLOCKS.MAP.PICKING_MARKER,
    posSet: BLOCKS.MAP.ACTIVE_MARKERS,
  },
  PickCoordsBlock,
);
